module.exports = __webpack_public_path__ + "static/img/gptnew1.c7a18905.png";